import { defineMessages } from 'react-intl';

const messages = defineMessages({
  has_image_and_not_alt: {
    id: 'has_image_and_not_alt',
    defaultMessage:
      'When the image is filled, the "Alternative text" field is required.',
  },
  has_file_and_has_url_curriculo: {
    id: 'has_file_and_has_url_curriculo',
    defaultMessage:
      'You cannot fill in both the curriculum URL and the file at the same time.',
  },
});

const isContentTypePessoa = (data) => data['@type'] === 'Pessoa';

const pessoaImageAltInvariant = (data, { formatMessage }) => {
  if (!isContentTypePessoa(data)) return {};

  const hasImage = Boolean(data.image);
  const hasAlt = Boolean(data.alt && data.alt.trim());
  const errors = {};

  if (hasImage && !hasAlt) {
    errors.alt = formatMessage(messages.has_image_and_not_alt);
  }

  return errors;
};

const pessoaCurriculoInvariant = (data, { formatMessage }) => {
  if (!isContentTypePessoa(data)) return {};

  const hasFile = Boolean(data.file);
  const hasUrlCurriculo = Boolean(
    data.url_curriculo && data.url_curriculo.trim(),
  );
  const errors = {};

  if (hasFile && hasUrlCurriculo) {
    const msg = formatMessage(messages.has_file_and_has_url_curriculo);
    errors.url_curriculo = msg;
    errors.file = msg;
  }

  return errors;
};

export const applyConfigPersonContentTypeValidation = (config) => {
  // Registra o invariant de validação para o tipo Pessoa
  config.settings = config.settings || {};
  config.settings.validation = config.settings.validation || {};
  config.settings.validation.invariants =
    config.settings.validation.invariants || [];

  const invariants = config.settings.validation.invariants;

  [pessoaImageAltInvariant, pessoaCurriculoInvariant].forEach((fn) => {
    if (!invariants.includes(fn)) {
      invariants.push(fn);
    }
  });

  return config;
};
